module.exports = __webpack_public_path__ + "static/assets/3aec74140126f59247a5513ff0541125.png";